import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { downloadHref, getApiErrorMessage } from '@/utils'

import { GetVendorsRequest } from './get-vendors'

export interface ExportVendorsRequest
  extends Omit<GetVendorsRequest, 'buildingId' | 'skip' | 'limit'> {
  buildingId: number
  fileName: string
}

export const exportVendors = async (params: Omit<ExportVendorsRequest, 'fileName'>) => {
  const response = await authAPI.get<Blob>('/vendor/export-csv', {
    params,
    responseType: 'blob',
  })
  return response.data
}

export const useExportVendors = () => {
  const objectUrlRef = useRef<string | null>(null)

  const mutation = useMutation({
    mutationFn: async ({ fileName, ...params }: ExportVendorsRequest) => {
      const blob = await exportVendors(params)
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
      objectUrlRef.current = URL.createObjectURL(blob)
      downloadHref(objectUrlRef.current, fileName)
      return objectUrlRef.current
    },
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
  })

  useEffect(() => {
    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
    }
  }, [])

  return mutation
}
